import {
    Grid,
    GridProps,
    Heading,
} from '@chakra-ui/react';
import {
    CakeToOrderRecommendationModel,
} from 'entities';
import {
    DeliveryArticleShortCard,
} from 'entities/delivery-article';
import React from 'react';

export type CakeToOrderPageMainRecommendationsSectionProps = {
    cakeToOrderRecommendations: CakeToOrderRecommendationModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const CakeToOrderPageMainRecommendationsSection
: React.FC<CakeToOrderPageMainRecommendationsSectionProps> = ({
    cakeToOrderRecommendations,
    ...props
}) => (
    <Grid
        {...props}
        gap="2rem"
    >
        <Heading
            size="md"
            textDecoration="underline"
        >
            Вместе с этим, мы предлагаем
        </Heading>
        <Grid
            templateColumns={{
                base: '1fr 1fr',
                lg: '1fr 1fr 1fr 1fr',
            }}
            gap="2rem"
        >
            {cakeToOrderRecommendations.map(({
                uid,
                name,
                weight,
                price,
                currency,
                image,
            }) => (
                <DeliveryArticleShortCard
                    name={name}
                    weight={weight}
                    price={price}
                    currencyAbbreviation={currency?.abbreviation || ''}
                    link={{
                        to: `/delivery/${uid}`,
                    }}
                    image={{
                        src: image?.url || '',
                    }}
                />
            ))}
        </Grid>
    </Grid>
);
